import { render, staticRenderFns } from "./TableUnitPricing.vue?vue&type=template&id=64455ae9&"
import script from "./TableUnitPricing.vue?vue&type=script&lang=js&"
export * from "./TableUnitPricing.vue?vue&type=script&lang=js&"
import style0 from "./TableUnitPricing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports